// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"455":"c9be91c7","977":"509d445c"}[chunkId] + ".chunk.js";
};